<template>
    <Popover class="relative isolate z-50 shadow">
        <a class="inline-flex items-center gap-x-1 text-sm font-semibold leading-1 text-white" v-if="navigation.to" :href="route(navigation.to)">{{navigation.label}}</a>
        <PopoverButton v-else class="inline-flex items-center gap-x-1 text-sm font-semibold leading-1 text-white">
            <span >{{navigation.label}}</span>
            <ChevronDownIcon class="h-5 w-5" aria-hidden="true" />
        </PopoverButton>
        <transition v-if="navigation.items" enter-active-class="transition ease-out duration-200" enter-from-class="opacity-0 translate-y-1" enter-to-class="opacity-100 translate-y-0" leave-active-class="transition ease-in duration-150" leave-from-class="opacity-100 translate-y-0" leave-to-class="opacity-0 translate-y-1">
            <PopoverPanel class="absolute left-1/2 z-10 mt-5 pt-3 flex w-screen max-w-max -translate-x-1/2 px-4">
                <div class="w-screen max-w-md flex-auto overflow-hidden rounded-3xl bg-white text-sm leading-6 shadow-lg ring-1 ring-gray-900/5">
                    <div class="p-4 grid grid-cols-2">
                        <div v-for="item in navigation.items" :key="item.key" class="group relative flex gap-x-6 rounded-lg p-4 hover:bg-gray-100">
                            <div>
                                <a :href="route(item.to)" class="font-semibold text-gray-900">
                                    {{ item.label }}
                                    <span class="absolute inset-0" />
                                </a>
                                <p class="mt-1 text-gray-600">{{ item.command }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </PopoverPanel>
        </transition>

    </Popover>
</template>

<script>
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/20/solid'

export default {
    name: 'NavigationLinks',
    components: {
        Popover,
        PopoverButton,
        PopoverPanel,
        ChevronDownIcon
    },
    props: {
        navigation: {
            type: Array,
            required: true
        }
    },
    created() {
        console.log(this.navigation)

    }
}
</script>
